import React from "react";
import CustomDiv from "../../Shared/CustomDiv";
import { Carousel } from "react-responsive-carousel";
import Text from "../../Shared/Text";
import { Divider } from "@mui/material";
import { sliderListFn } from "../../Services/SliderList";
import { useMutation } from "react-query";
import { useState } from "react";
import { useEffect } from "react";
import { testimonialFn } from "../../Services/Testimonial";
import { bannerFn } from "../../Services/Banner";
import { allFiltersFn } from "../../Services/AllFilters/index,";
import { useNavigate } from "react-router-dom";
import HomeProduct from "../../Components/Products/HomeProduct";

const LandingPage = () => {
  const [open, setOpen] = useState(null);
  const [data, setData] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [banners, setBanners] = useState([]);
  const [spices, setSpices] = useState([]);
  const handleActiveHover = (id) => {
    setOpen(id);
  };
  const handleCloseHover = () => {
    setOpen(null);
  };

  const { mutate } = useMutation(sliderListFn, {
    onSuccess: (response) => {
      setData(response.data.data);
    },
  });

  const { mutate: testimonial } = useMutation(testimonialFn, {
    onSuccess: (response) => {
      setTestimonials(response.data.data);
    },
  });

  const { mutate: banner } = useMutation(bannerFn, {
    onSuccess: (response) => {
      setBanners(response.data.data);
    },
  });

  useEffect(() => {
    mutate();
    testimonial();
    banner();
  }, []);

  const navigate = useNavigate();
  const { mutate: allFilters } = useMutation(allFiltersFn, {
    onSuccess: (response) => {
      setSpices(response.data.data.product_list);
    },
  });

  useEffect(() => {
    allFilters({
      category_id: 5,
      sub_category_id: "",
      brand_id: "",
      color_id: "",
      max_price: "",
      min_price: "",
      rating: "",
    });
  }, []);

  return (
    <CustomDiv className="flex flex-col w-full">
      <div className="lg:pt-16 pt-0">
        <Carousel
          autoPlay
          showStatus={false}
          showThumbs={false}
          className="zzz-carousel"
          infiniteLoop={true}
        >
          {data?.map((slider) => {
            return (
              <div key={slider.id}>
                <img
                  alt=""
                  src={slider.image}
                  className="relative lg:h-[500px] h-[150px]"
                />
              </div>
            );
          })}
        </Carousel>
      </div>
      <HomeProduct />

      <CustomDiv className="grid grid-cols-2 flex-col-reverse lg:gap-10 gap-2 justify-center items-center my-8 bg-[#F2F8F9] p-4 ">
        {banners?.slice(1, 3).map((banner) => {
          return (
            <div className="flex flex-col gap-2 lg:gap-5">
              <Divider textAlign="left" className="font-bold lg:text-xl">
                <Text>{banner.brand_name}</Text>
              </Divider>
              <div className="flex gap-2 lg:gap-10">
                <img src={banner.image} alt="" />
              </div>
            </div>
          );
        })}
      </CustomDiv>

      <div className="w-full lg:flex justify-center items-center">
        {testimonials?.slice(0, 4).map((test) => {
          return (
            <div className="card lg:w-[25%]">
              <p className="card-title">{test?.name}</p>
              <div className="flex flex-row w-full justify-between items-center my-2 px-5">
                <p className="font-bold">{test?.client_profile}</p>
                <p className="">{test?.company}</p>
              </div>
              <p className="small-desc">{test?.message.slice(0, 75)}...</p>
              <div className="go-corner">
                <div className="go-arrow">→</div>
              </div>
              <div className="mt-10">
                <img
                  className="h-16 w-16 rounded-full ml-14"
                  src={test?.image}
                  alt=""
                />
                <p className="my-5">{test?.url}</p>
              </div>
            </div>
          );
        })}
      </div>
    </CustomDiv>
  );
};
export default LandingPage;
